var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import MuiChip from '@mui/material/Chip';
export const Chip = (_a) => {
    var { label, disabled, variant = 'filled', selected = false, leftIcon, rightIcon, clickable = true, dataQa = 'chip-core', size = 'medium', bold = false } = _a, otherProps = __rest(_a, ["label", "disabled", "variant", "selected", "leftIcon", "rightIcon", "clickable", "dataQa", "size", "bold"]);
    const [selectedChip, setSelectedChip] = useState(selected);
    useEffect(() => {
        setSelectedChip(selected);
    }, [selected]);
    const handleClick = () => {
        if (disabled || !clickable)
            return;
        setSelectedChip(!selectedChip);
    };
    return (React.createElement(MuiChip, Object.assign({ "data-qa": dataQa }, otherProps, { label: label, onDelete: rightIcon &&
            (() => {
                return;
            }), icon: leftIcon, deleteIcon: rightIcon, disabled: disabled, variant: variant, size: size, clickable: clickable, onClick: handleClick, sx: Object.assign({ fontWeight: bold ? 'bold' : 'normal' }, otherProps.sx), className: selectedChip ? 'MuiChip-selected' : '' })));
};
